import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterNoticeAapraitre extends ISearchLimitOffset {
    SortField?: string;
    IsDescending?:boolean;
    SocieteIds?: number [];
  }

 
  export const getDefaultFilterNoticeAapraitre = (): IFilterNoticeAapraitre => ({
    Offset: 0,
    Limit: 10,
    SortField: "Titre",
    IsDescending: true,
    SocieteIds :[],
  });

  export const dtoToFilterNoticeAapraitre = (dto: IFilterNoticeAapraitre): IFilterNoticeAapraitre => {
  
    return {
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      SortField: dto.SortField,
      SocieteIds: dto.SocieteIds !== undefined ? dto.SocieteIds : [],
    };
  };
  
  export const filterToQueryNoticeAapraitre = (filter: IFilterNoticeAapraitre): IFilterNoticeAapraitre => {
    const dto: IFilterNoticeAapraitre = {};
 
    
    if (filter?.SocieteIds !== undefined ) { // ??
      dto.SocieteIds = filter.SocieteIds;
    } 


    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterNoticesAapraitre", JSON.stringify(dto));
  
    return dto;
  };
  
  
 